import React from "react";
import { Row, Col, FormGroup, Card, CardBody, Button, Table, ButtonToolbar } from "reactstrap";

import { connect } from "react-redux";
import { searchProduct } from "../../datautils/actions/adminActions";
import PanelHeader from "../../components/PanelHeader/PanelHeader";

import { ADMIN_PRODUCT_VIEW } from "../../utils/constants/clientUrls";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import { sortIcon } from "../../utils/constants/icons";
import { PER_PAGE } from "../../utils/constants/index";
import ErrorBlock from "../../components/ErrorBlock/ErrorBlock";
import { getMediaUrl } from "../../utils/helpers/HelperFunctions";
import ImageZoom from "../../components/ImageZoom";

class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      globalSearchKeyword: "",
      pageNumber: 1,
      pageSize: PER_PAGE,
      sortField: "productId",
      ascending: false,
      currentTab: "",
    };
  }

  componentDidMount() {
    this.searchProduct();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.searchProduct();
    }
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          pageNumber: 1,
        },
        () => this.searchProduct()
      );
    }
  };

  searchButton = (e) => {
    this.setState(
      {
        pageNumber: 1,
      },
      () => this.searchProduct()
    );
  };
  sortButton = (field, order) => (e) => {
    e.preventDefault();

    this.setState(
      {
        sortField: field,
        ascending: order,
      },
      () => this.searchProduct()
    );
  };

  searchHandler = (e) => {
    this.setState({ globalSearchKeyword: e.target.value });
  };

  filterData = (e) => {
    this.setState(
      {
        currentTab: e.target.value,
        globalSearchKeyword: "",
        pageNumber: 1,
      },
      () => this.searchProduct()
    );
  };

  searchProduct = () => {
    const { globalSearchKeyword, currentTab, pageNumber, pageSize, sortField, ascending } = this.state;

    const reqData = {
      globalSearchKeyword,
      fieldNameKeyword: [{ key: "status", operation: "EQUAL_TO", value: currentTab }],
      paginationOptions: {
        pageNumber,
        pageSize,
        sortOptions: [{ sortField, ascending }],
      },
    };
    this.props.searchProduct(reqData);
  };

  handleChange = (input) => () => {
    this.props.history.push(ADMIN_PRODUCT_VIEW + input);
  };

  changePage = (page) => () => {
    this.setState({ pageNumber: page });
  };

  renderPagination = () => {
    const mainData = this.props.responseVal.dObjectData.productList.data;
    if (mainData.totalNoOfPages > 1) {
      return (
        <CustomPagination
          pageNumber={this.state.pageNumber}
          totalNoOfPages={mainData.totalNoOfPages}
          changePage={this.changePage}
          hasPrevious={mainData.hasPrevious}
          hasNext={mainData.hasNext}
        />
      );
    }
  };

  render() {
    const { responseVal } = this.props;
    const { globalSearchKeyword, ascending, pageNumber, pageSize, currentTab } = this.state;

    const dataLoaded = responseVal.dObjectData?.productList?.data?.products;

    return (
      <div>
        <PanelHeader />
        <div className="content">
          <Row>
            <Col xs={12}>
              {responseVal.errors && responseVal.status === "failure" ? (
                <ErrorBlock errors={responseVal.errors} />
              ) : null}
            </Col>
            <Col xs={12}>
              <ButtonToolbar>
                {" "}
                <Button size="sm" value="1" onClick={this.filterData} color={currentTab === "1" ? "primary" : ""}>
                  ACTIVE
                </Button>
                <Button size="sm" value="0" onClick={this.filterData} color={currentTab === "0" ? "primary" : ""}>
                  INACTIVE
                </Button>
                <Button size="sm" value="" onClick={this.filterData} color={currentTab === "" ? "primary" : ""}>
                  ALL
                </Button>
              </ButtonToolbar>
            </Col>
            <Col xs={12}>
              <Card>
                <CardBody className="listings">
                  <React.Fragment>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <div className="has-search">
                            <div className="input-group">
                              <input
                                type="search"
                                value={globalSearchKeyword}
                                name="globalSearchKeyword"
                                className="form-control"
                                placeholder="Search Product..."
                                onChange={this.searchHandler}
                                onKeyDown={this.handleKeyDown}
                                style={{ background: "#f5f5f5" }}
                                autoComplete="off"
                              />
                              <div className="input-group-append">
                                <Button color="primary" onClick={this.searchButton}>
                                  <i className="now-ui-icons ui-1_zoom-bold" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md="8">{dataLoaded ? this.renderPagination() : ""}</Col>
                    </Row>

                    <Table responsive className="table-striped table-bordered">
                      <thead>
                        <tr className="text-primary">
                          <th className="text-center">#</th>
                          <th>Primary Image</th>
                          <th onClick={this.sortButton("productId", ascending ? false : true)}>
                            Product ID <img alt="sort" className="sort-icon" src={sortIcon} />
                          </th>
                          <th onClick={this.sortButton("title", ascending ? false : true)}>
                            Product Title <img alt="sort" className="sort-icon" src={sortIcon} />
                          </th>
                          <th>Variants</th>
                          <th>Category</th>
                          <th>Brand</th>

                          <th>Status</th>
                          <th>Indexed</th>

                          <th>Sku Unique Style Code</th>

                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataLoaded ? (
                          dataLoaded.length ? (
                            dataLoaded.map((row, index) => {
                              const cname =
                                row.status === "ACTIVE"
                                  ? "success"
                                  : row.status === "INACTIVE"
                                  ? "danger"
                                  : row.status === "ONHOLD"
                                  ? "warning"
                                  : "primary";

                              let kvLabel = "";
                              row.primaryCatFields &&
                                Object.keys(row.primaryCatFields).map((o) => {
                                  const k = row.primaryCatFields[o];
                                  return (kvLabel = kvLabel + k.name + ": " + k.value + ", ");
                                });

                              return (
                                <tr key={index}>
                                  <td className="text-center">{pageNumber * pageSize + (index + 1) - pageSize}</td>

                                  <td>
                                    <ImageZoom
                                      src={getMediaUrl({
                                        fileId: row.defaultFileId,
                                        fileExt: row.defaultFileExt,
                                      })}
                                      alt=""
                                      className="list-img img-fluid"
                                      style={{
                                        height: "50px",
                                        width: "auto",
                                      }}
                                    />
                                  </td>
                                  <td onClick={this.handleChange(row.productId)} className="cursor">
                                    {row.productId}
                                  </td>
                                  <td onClick={this.handleChange(row.productId)} className="cursor">
                                    {row.title}
                                  </td>

                                  <td>{kvLabel && kvLabel.slice(0, -2)}</td>

                                  <td>{row.categoryName}</td>
                                  <td>{row.brandName}</td>

                                  <td>{row.status}</td>
                                  <td>
                                    {row.esIndexStatus === "INDEXED" ? (
                                      <span className="text-success">YES</span>
                                    ) : (
                                      <span className="text-danger">NO</span>
                                    )}
                                  </td>
                                  <td>{row.petStyleCode}</td>

                                  <td className="text-right">
                                    <Button
                                      className={`btn-simple btn-light btn-${cname}`}
                                      size="xs"
                                      onClick={this.handleChange(row.productId)}
                                    >
                                      View
                                    </Button>{" "}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="11" className="no-data">
                                No data available
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="11" />
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {this.props.isLoading ? <div className="loader" /> : null}
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.ui.isLoading,
    responseVal: state.resHandlerVal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchProduct: (reqData) => dispatch(searchProduct(reqData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
